import React, { useState } from 'react';
import { FormGroup, Label } from 'reactstrap';
import { Input } from '../../components';
import { BaseGeneralSetting } from '../../common/Types';
import { Controller, Control } from 'react-hook-form';

type Props = {
    control: Control<any>;
    reportingWindow: BaseGeneralSetting;
};

const ReportingWindowSettings = (props) => {
    const [employerMeasureType, setEmployerMeasureType] = useState<string>(
        props.reportingWindow.employeeSurveyMeasureType,
    );
    const [graduateMeasureType, setGraduateMeasureType] = useState<string>(
        props.reportingWindow.employeeSurveyMeasureType,
    );

    return (
        <>
            <Controller
                name="reportingWindow.id"
                control={props.control}
                render={({ field }) => (
                    <input type="hidden" {...field} value={field.value ?? props.reportingWindow.id ?? ''} />
                )}
            />
            <Controller
                name="reportingWindow.title"
                control={props.control}
                render={({ field }) => (
                    <input type="hidden" {...field} value={field.value ?? props.reportingWindow.title ?? ''} />
                )}
            />
            <Controller
                name="reportingWindow.cutScore"
                control={props.control}
                render={({ field }) => (
                    <input type="hidden" {...field} value={field.value ?? props.reportingWindow.cutScore ?? ''} />
                )}
            />
            <FormGroup>
                <Label for="reportingWindow.activeYear">Active Year</Label>
                <Controller
                    name="reportingWindow.activeYear"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="text"
                            id="reportingWindow.activeYear"
                            {...field}
                            value={field.value ?? props.reportingWindow.activeYear ?? ''}
                            style={{ width: '100px' }}
                        />
                    )}
                />
            </FormGroup>
            <FormGroup>
                <Label for="reportingWindow.yearAvarageStart">Average Start Year</Label>
                <Controller
                    name="reportingWindow.yearAvarageStart"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="text"
                            id="reportingWindow.yearAvarageStart"
                            {...field}
                            value={field.value ?? props.reportingWindow.yearAvarageStart ?? ''}
                            style={{ width: '100px' }}
                        />
                    )}
                />
            </FormGroup>
            <FormGroup>
                <Label for="reportingWindow.reportingWindow">Reporting Window</Label>
                <Controller
                    name="reportingWindow.reportingWindow"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="select"
                            id="reportingWindow.reportingWindow"
                            {...field}
                            value={field.value ?? props.reportingWindow.reportingWindow ?? ''}
                            style={{ width: '100px' }}
                        >
                            <option value="3">3 years</option>
                            <option value="4">4 years</option>
                            <option value="5">5 years</option>
                            <option value="6">6 years</option>
                        </Input>
                    )}
                />
            </FormGroup>
            <FormGroup>
                <Label for="reportingWindow.annualReportMailbox">Annual Report Mailbox</Label>
                <Controller
                    name="reportingWindow.annualReportMailbox"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="text"
                            id="reportingWindow.annualReportMailbox"
                            {...field}
                            value={field.value ?? props.reportingWindow.annualReportMailbox ?? ''}
                            style={{ width: '100px' }}
                        />
                    )}
                />
            </FormGroup>
            <hr style={{ borderColor: 'black', marginTop: '3rem', marginBottom: '3rem' }} />
            <FormGroup>
                <Label for="reportingWindow.outcomeMeasure">Attrition/Retention Designation</Label>
                <Controller
                    name="reportingWindow.outcomeMeasure"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="select"
                            id="reportingWindow.outcomeMeasure"
                            {...field}
                            value={field.value ?? props.reportingWindow.outcomeMeasure ?? ''}
                            style={{ width: '150px' }}
                        >
                            <option value="Attrition">Attrition</option>
                            <option value="Retention">Retention</option>
                        </Input>
                    )}
                />
            </FormGroup>
            <FormGroup>
                <Label for="reportingWindow.attritionRetentionThreshold">Attrition/Retention Threshold</Label>
                <Controller
                    name="reportingWindow.attritionRetentionThreshold"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="number"
                            id="reportingWindow.attritionRetentionThreshold"
                            {...field}
                            value={field.value ?? props.reportingWindow.attritionRetentionThreshold ?? ''}
                            style={{ width: '100px' }}
                        />
                    )}
                />
            </FormGroup>
            <FormGroup>
                <Label for="reportingWindow.positivePlacementThreshold">Positive Placement Threshold</Label>
                <Controller
                    name="reportingWindow.positivePlacementThreshold"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="number"
                            id="reportingWindow.positivePlacementThreshold"
                            {...field}
                            value={field.value ?? props.reportingWindow.positivePlacementThreshold ?? ''}
                            style={{ width: '100px' }}
                        />
                    )}
                />
            </FormGroup>
            <hr style={{ borderColor: 'black', marginTop: '3rem', marginBottom: '3rem' }} />
            <FormGroup>
                <Label for="reportingWindow.questionLabelType">Survey Question Label Type</Label>
                <Controller
                    name="reportingWindow.questionLabelType"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="select"
                            id="reportingWindow.questionLabelType"
                            {...field}
                            value={field.value ?? props.reportingWindow.questionLabelType ?? ''}
                            style={{ width: '150px' }}
                        >
                            <option value="Letters">Letters</option>
                            <option value="Numbers">Numbers</option>
                        </Input>
                    )}
                />
            </FormGroup>
            <hr style={{ borderColor: 'black', marginTop: '3rem', marginBottom: '3rem' }} />
            <h4>Employer Survey Settings</h4>
            <FormGroup>
                <Label for="reportingWindow.escognitiveQuestions">Cognitive Question Count</Label>
                <Controller
                    name="reportingWindow.escognitiveQuestions"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="number"
                            id="reportingWindow.escognitiveQuestions"
                            {...field}
                            value={field.value ?? props.reportingWindow.escognitiveQuestions ?? ''}
                            style={{ width: '100px' }}
                        />
                    )}
                />
            </FormGroup>
            <FormGroup>
                <Label for="reportingWindow.espsychomotorQuestions">Psychomotor Question Count</Label>
                <Controller
                    name="reportingWindow.espsychomotorQuestions"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="number"
                            id="reportingWindow.espsychomotorQuestions"
                            {...field}
                            value={field.value ?? props.reportingWindow.espsychomotorQuestions ?? ''}
                            style={{ width: '100px' }}
                        />
                    )}
                />
            </FormGroup>
            <FormGroup>
                <Label for="reportingWindow.esaffectiveQuestions">Affective Question Count</Label>
                <Controller
                    name="reportingWindow.esaffectiveQuestions"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="number"
                            id="reportingWindow.esaffectiveQuestions"
                            {...field}
                            value={field.value ?? props.reportingWindow.esaffectiveQuestions ?? ''}
                            style={{ width: '100px' }}
                        />
                    )}
                />
            </FormGroup>
            <FormGroup>
                <Label for="reportingWindow.surveyMeasureType">Survey Measure Type</Label>
                <Controller
                    name="reportingWindow.employeeSurveyMeasureType"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="select"
                            id="reportingWindow.employeeSurveyMeasureType"
                            {...field}
                            value={field.value ?? props.reportingWindow.employeeSurveyMeasureType ?? ''}
                            style={{ width: '100px' }}
                            onChange={(e) => {
                                field.onChange(e.target.value);
                                setEmployerMeasureType(e.target.value);
                            }}
                        >
                            <option value="Returned">Returned</option>
                            <option value="Sent">Sent</option>
                        </Input>
                    )}
                />
            </FormGroup>
            <FormGroup>
                <Label for="reportingWindow.employerSurveysThreshold">{employerMeasureType} Threshold</Label>
                <Controller
                    name="reportingWindow.employerSurveysThreshold"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="number"
                            id="reportingWindow.employerSurveysThreshold"
                            {...field}
                            value={field.value ?? props.reportingWindow.employerSurveysThreshold ?? ''}
                            style={{ width: '100px' }}
                        />
                    )}
                />
            </FormGroup>
            <FormGroup>
                <Label for="reportingWindow.employerSurveysThreshold">Satisfaction Threshold</Label>
                <Controller
                    name="reportingWindow.employeeSurveySatisfactionThreshold"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="number"
                            id="reportingWindow.employeeSurveySatisfactionThreshold"
                            {...field}
                            value={field.value ?? props.reportingWindow.employeeSurveySatisfactionThreshold ?? ''}
                            style={{ width: '100px' }}
                        />
                    )}
                />
            </FormGroup>
            <FormGroup>
                <Label for="reportingWindow.employeeSurveyCutScore">Cut Score</Label>
                <Controller
                    name="reportingWindow.employeeSurveyCutScore"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="number"
                            id="reportingWindow.employeeSurveyCutScore"
                            {...field}
                            value={field.value ?? props.reportingWindow.employeeSurveyCutScore ?? ''}
                            style={{ width: '100px' }}
                        />
                    )}
                />
            </FormGroup>
            <hr style={{ borderColor: 'black', marginTop: '3rem', marginBottom: '3rem' }} />
            <h4>Graduate Survey Settings</h4>
            <FormGroup>
                <Label for="reportingWindow.gscognitiveQuestions">Cognitive Question Count</Label>
                <Controller
                    name="reportingWindow.gscognitiveQuestions"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="number"
                            id="reportingWindow.gscognitiveQuestions"
                            {...field}
                            value={field.value ?? props.reportingWindow.gscognitiveQuestions ?? ''}
                            style={{ width: '100px' }}
                        />
                    )}
                />
            </FormGroup>
            <FormGroup>
                <Label for="reportingWindow.gspsychomotorQuestions">Psychomotor Question Count</Label>
                <Controller
                    name="reportingWindow.gspsychomotorQuestions"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="number"
                            id="reportingWindow.gspsychomotorQuestions"
                            {...field}
                            value={field.value ?? props.reportingWindow.gspsychomotorQuestions ?? ''}
                            style={{ width: '100px' }}
                        />
                    )}
                />
            </FormGroup>
            <FormGroup>
                <Label for="reportingWindow.gsaffectiveQuestions">Affective Question Count</Label>
                <Controller
                    name="reportingWindow.gsaffectiveQuestions"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="number"
                            id="reportingWindow.gsaffectiveQuestions"
                            {...field}
                            value={field.value ?? props.reportingWindow.gsaffectiveQuestions ?? ''}
                            style={{ width: '100px' }}
                        />
                    )}
                />
            </FormGroup>
            <FormGroup>
                <Label for="reportingWindow.graduateSurveyMeasureType">Measure Type</Label>
                <Controller
                    name="reportingWindow.graduateSurveyMeasureType"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="select"
                            id="reportingWindow.graduateSurveyMeasureType"
                            {...field}
                            value={field.value ?? props.reportingWindow.graduateSurveyMeasureType ?? ''}
                            style={{ width: '100px' }}
                            onChange={(e) => {
                                field.onChange(e.target.value);
                                setGraduateMeasureType(e.target.value);
                            }}
                        >
                            <option value="Returned">Returned</option>
                            <option value="Sent">Sent</option>
                        </Input>
                    )}
                />
            </FormGroup>
            <FormGroup>
                <Label for="reportingWindow.graduateSurveysThreshold">{graduateMeasureType} Threshold</Label>
                <Controller
                    name="reportingWindow.graduateSurveysThreshold"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="number"
                            id="reportingWindow.graduateSurveysThreshold"
                            {...field}
                            value={field.value ?? props.reportingWindow.graduateSurveysThreshold ?? ''}
                            style={{ width: '100px' }}
                        />
                    )}
                />
            </FormGroup>
            <FormGroup>
                <Label for="reportingWindow.graduateSurveySatisfactionThreshold">Satisfaction Threshold</Label>
                <Controller
                    name="reportingWindow.graduateSurveySatisfactionThreshold"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="number"
                            id="reportingWindow.graduateSurveySatisfactionThreshold"
                            {...field}
                            value={field.value ?? props.reportingWindow.graduateSurveySatisfactionThreshold ?? ''}
                            style={{ width: '100px' }}
                        />
                    )}
                />
            </FormGroup>
            <FormGroup>
                <Label for="reportingWindow.graduateSurveyCutScore">Cut Score</Label>
                <Controller
                    name="reportingWindow.graduateSurveyCutScore"
                    control={props.control}
                    render={({ field }) => (
                        <Input
                            type="number"
                            id="reportingWindow.graduateSurveyCutScore"
                            {...field}
                            value={field.value ?? props.reportingWindow.graduateSurveyCutScore ?? ''}
                            style={{ width: '100px' }}
                        />
                    )}
                />
            </FormGroup>
        </>
    );
};

export default ReportingWindowSettings;
